import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendar, MatDatepicker } from '@angular/material/datepicker';
import { FiltroFirma } from 'src/app/shared/models/filtros';
import { FiltroSqp } from '../../../sqpFiltroSuperior/models/filtro-sqp';
import { TipoFiltro } from '../../../sqpFiltroSuperior/models/tipo-filtro';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ModalMessageComponent } from '../../../../modals/modal-message/modal-message.component';
import { CalendarioRangoService } from '../../services/calendario-rango.service';
import { TooltipMessages } from 'src/app/shared/models/tooltip.mesages';


@Component({
  selector: 'app-calendario-rango',
  templateUrl: './calendario-rango.component.html',
  styleUrls: ['./calendario-rango.component.css']
})
export class CalendarioRangoComponent implements OnInit {

  isOpcionesPeriodo: boolean = false;
  isMostrarInputs: boolean = false;
  formRange: FormGroup = new FormGroup({});
  pastYear: string = '';
  currentYear: string = '';
  @Input() periodoTiempoInicial: string = '';
  periodoTiempo: string = '';
  private isInsideCalendar = false;
  disableRipple: boolean;
  @Input() limpiarTodo: {num: number, clear: boolean};
  @Output() filtroRangoSqpEmitter: EventEmitter<FiltroSqp>= new EventEmitter<FiltroSqp>();
  @Input() limpiarTodosFiltrosSqp:number;
  mostrarErrorInput: boolean = false;
  mensajeError:string = '';

  constructor(private eRef: ElementRef,
              private dialog: MatDialog,
              private calendarioRangoService: CalendarioRangoService) {
    this.inicializaFormularioRange();
   }

  ngOnChanges(changes: SimpleChanges){
    if(changes.limpiarTodosFiltrosSqp?.currentValue>0 && this.periodoTiempoInicial!=='Fecha de envío') this.limpiarFiltro();
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear().toString();
    this.pastYear = (new Date().getFullYear()-1).toString();
    //añadimos el siguiente if para que si sales del panel de control y vuelves a entrar se muestre el último rango seleccionado de Fecha de envío y no vuelva a 12 meses
    if(this.periodoTiempoInicial == 'Fecha de envío' && this.calendarioRangoService.rangoSeleccionado !== ''){
      this.periodoTiempo = this.calendarioRangoService.rangoSeleccionado;
    }else this.periodoTiempo = this.periodoTiempoInicial;
    if(this.periodoTiempo=='Fecha de envío'){
      this.seleccionarFechas('12meses');
    }
  }

  abrirMenu(){
    this.isOpcionesPeriodo = !this.isOpcionesPeriodo;
  }

  inicializaFormularioRange(){
    this.formRange = new FormGroup({
      start: new FormControl<Date | null>(null),
      end: new FormControl<Date | null>(null)
    })
  }

  get start(){return this.formRange.controls['start']}
  get end(){return this.formRange.controls['end']}

  seleccionarFechas(fecha: string, rango?:string){
    if(fecha !== 'rango'){
      this.start.setValue(null);
      this.end.setValue(null);
    }
    // if(rango && rango == 'desde') this.end.setValue(null);
    let fechaDesde: Date | null;
    let fechaHasta: Date | null;
    let hoy = new Date();
    let year = hoy.getFullYear();
    switch(fecha){
      case 'hoy':
        fechaDesde = this.getMedianoche(hoy);
        fechaHasta = new Date();
        this.periodoTiempo = 'Hoy';
        this.isOpcionesPeriodo = false;
        this.isMostrarInputs = false;
        break;
      case '7':
        let fecha7 = new Date(hoy.getTime()-(7*24*60*60*1000));
        fechaDesde = this.getMedianoche(fecha7);
        fechaHasta = new Date();
        this.periodoTiempo = 'Últimos 7 días';
        this.isOpcionesPeriodo = false;
        this.isMostrarInputs = false;
        break;
      case '30':
        let fecha30 = new Date(hoy.getTime()-(30*24*60*60*1000));
        fechaDesde = this.getMedianoche(fecha30);
        fechaHasta = new Date();
        this.periodoTiempo = 'Últimos 30 días';
        this.isOpcionesPeriodo = false;
        this.isMostrarInputs = false;
        break;
      case '12meses':
        const today = new Date();
        const lastYear = new Date();
        lastYear.setFullYear(today.getFullYear() - 1);
        fechaDesde = this.getMedianoche(lastYear);
        fechaHasta = today;
        this.periodoTiempo = 'Últimos 12 meses';
        this.isOpcionesPeriodo = false;
        this.isMostrarInputs = false;
        break;
      case 'current':
        fechaDesde = new Date(year, 0, 1);
        fechaHasta = new Date();
        this.periodoTiempo = 'Este año';
        this.isOpcionesPeriodo = false;
        this.isMostrarInputs = false;
        break;
      case 'past':
        let pastYear = year-1;
        fechaDesde = new Date(pastYear, 0 ,1);
        fechaHasta = new Date(pastYear, 11, 31);
        this.periodoTiempo = 'Año pasado';
        this.isOpcionesPeriodo = false;
        this.isMostrarInputs = false;
        break;
      case 'rango':
        this.mostrarErrorInput = false;
        fechaDesde = this.start.value ? (this.start.value as any)?.toDate() : null;
        fechaHasta = (this.end.value) ? (this.end.value as any)?.toDate() : null;
        let desde = fechaDesde?.toLocaleDateString().split('/');
        let hasta = fechaHasta?.toLocaleDateString().split('/');
        if (fechaDesde && fechaHasta) {
          if(fechaHasta < fechaDesde){
            this.mostrarErrorInput = true;
            this.mensajeError = 'La fecha desde debe ser más antigua que la fecha hasta.'
            return;
          }
          const startDate = new Date(fechaDesde);
          const endDate = new Date(fechaHasta);
          const twelveMonthsFromStart = new Date(startDate);
          twelveMonthsFromStart.setMonth(twelveMonthsFromStart.getMonth() + 12);
          if (endDate > twelveMonthsFromStart) {
            this.mostrarErrorInput = true;
            this.mensajeError = 'El rango no puede ser mayor a 12 meses.'
            return;
          }
          const currentYear = new Date().getFullYear().toString();

          if(desde[2] != hasta[2]) {
            // Different years - always show year
            this.periodoTiempo = `${desde[0]} ${this.traducirMes(desde[1])} ${desde[2]} - ${hasta[0]} ${this.traducirMes(hasta[1])} ${hasta[2]}`;
          } else if(desde[1] == hasta[1]) {
            // Same month and year
            if(desde[2] != currentYear) {
              // Different year than current - show year
              this.periodoTiempo = `${desde[0]} - ${hasta[0]} ${this.traducirMes(desde[1])} ${desde[2]}`;
            } else {
              // Same year as current - don't show year
              this.periodoTiempo = `${desde[0]} - ${hasta[0]} ${this.traducirMes(desde[1])}`;
            }
          } else {
            // Same year, different months
            if(desde[2] != currentYear) {
              // Different year than current - show year
              this.periodoTiempo = `${desde[0]} ${this.traducirMes(desde[1])} - ${hasta[0]} ${this.traducirMes(hasta[1])} ${desde[2]}`;
            } else {
              // Same year as current - don't show year
              this.periodoTiempo = `${desde[0]} ${this.traducirMes(desde[1])} - ${hasta[0]} ${this.traducirMes(hasta[1])}`;
            }
          }
          this.isInsideCalendar = false;
          this.isOpcionesPeriodo = false;
          this.isMostrarInputs = false;
        }
        break;
    }

    if(fechaHasta) fechaHasta.setDate(fechaHasta.getDate()+1);

    let filtroSqp: FiltroSqp = {
      tipoFiltro: TipoFiltro.FECHA,
      titulo: this.periodoTiempoInicial,
      valoresSeleccionados:{
        valorFechaDesde:fechaDesde,
        valorFechaHasta:fechaHasta
      }
    }

    this.calendarioRangoService.rangoSeleccionado = this.periodoTiempo;

    if(filtroSqp.tipoFiltro!==TipoFiltro.FECHA || (filtroSqp.tipoFiltro==TipoFiltro.FECHA && filtroSqp.valoresSeleccionados.valorFechaDesde !== null && filtroSqp.valoresSeleccionados.valorFechaHasta !== null)) this.filtroRangoSqpEmitter.emit(filtroSqp)
  }

  @HostListener('document:click', ['$event']) clickout(event:any) {
    const clickedElement = event.target as HTMLElement;
    if((!this.eRef.nativeElement.contains(clickedElement) &&
       !this.isInsideCalendar) ) {
      this.isOpcionesPeriodo = false;
      if(this.periodoTiempo == 'Periodo personalizado' && (this.start.value == null || this.end.value == null)){
        this.periodoTiempo = this.periodoTiempoInicial;
      }
    }
  }

  mostrarInputCalendarios(){
    this.isMostrarInputs = !this.isMostrarInputs;
    this.periodoTiempo = 'Periodo personalizado';
    this.isInsideCalendar = true;
  }

  getMedianoche(fecha: Date): Date{
    return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), 0, 0, 0);
  }

  limpiarFiltro(){
    this.start.setValue(null);
    this.end.setValue(null);

    let filtroSqp: FiltroSqp = {
      tipoFiltro: TipoFiltro.FECHA,
      titulo: this.periodoTiempoInicial,
      valoresSeleccionados:{
        valorFechaDesde:null,
        valorFechaHasta:null
      }
    }

    this.filtroRangoSqpEmitter.emit(filtroSqp)
    this.periodoTiempo = this.periodoTiempoInicial;
    this.isOpcionesPeriodo = false;
    this.isMostrarInputs = false;
    this.isInsideCalendar = false;
  }

  traducirMes(mes: string): string{
    switch(mes){
      case '1': return 'ene';
      case '2': return 'feb';
      case '3': return 'mar';
      case '4': return 'abr';
      case '5': return 'may';
      case '6': return 'jun';
      case '7': return 'jul';
      case '8': return 'ago';
      case '9': return 'sept';
      case '10': return 'oct';
      case '11': return 'nov';
      case '12': return 'dic';
    }
    return ''
  }

  getTooltip(filtro: string){
    if (filtro == "Fecha de envío") return TooltipMessages.filtro_fechaEnvio;
    else if (filtro == "Fecha contrato") return TooltipMessages.filtro_fechaContrato;
    else return '';
  }

}
